'use strict';

const formValidation = require('./components/formValidation');
const clientSideValidation = require('./components/clientSideValidation');
const emailValidation = require('./components/emailValidation');
const passwordValidation = require('./components/passwordValidation');

$(() => {

    $('form.reset-password-form').on('submit', function (e) {
        var form = $(this);
        e.preventDefault();
        $.spinner().start();

        // エラーメッセージの除去
        clientSideValidation.functions.clearForm(form.get(0));

        // emailの正規表現チェック
        let email = $('#passwordreset-email');
        var errors = [];
        // Validate email address
        if (email.val().length > 80) {
            errors.push(email.data('range-error'))
        }
        if (!emailValidation(email.val())) {
            errors.push(email.data('pattern-mismatch'))
        }
        if(errors.length) {
            email.addClass('is-invalid');
            email.parents('.form-group').find('.invalid-feedback').html(errors.join('<br/>'));
            $.spinner().stop();
            return false;
        }

        var url = form.attr('action');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                $.spinner().stop();
                if (data.success) {
                    location.href = data.redirectUrl;
                } else {
                    formValidation(form, data);
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $.spinner().stop();
                }
            }
        });
    });

    $('form.new-password-form').on('submit', function (e) {
        var form = $(this);
        e.preventDefault();
        $.spinner().start();

        // エラーメッセージの除去
        clientSideValidation.functions.clearForm(form.get(0));

        // passswordの正規表現チェック
        let password = $('#passwordreset-newpassword');
        if (!passwordValidation(password.val())) {
            password.addClass('is-invalid');
            password.parents('.form-group').find('.invalid-feedback').text(password.data('pattern-mismatch'));
            $.spinner().stop();
            return false;
        }

        var url = form.attr('action');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                $.spinner().stop();
                if (data.success || data.tokenError) {
                    location.href = data.redirectUrl;
                } else {
                    formValidation(form, data);
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $.spinner().stop();
                }
            }
        });
    });

    $('#passwordreset-newpassword').on('blur', function (e) {
        var form = $('form.new-password-form');
        e.preventDefault();
        clientSideValidation.functions.clearForm(form.get(0));
        // passswordの正規表現チェック
        let password = $('#passwordreset-newpassword');
        if (!passwordValidation(password.val())) {
            password.addClass('is-invalid');
            password.parents('.form-group').find('.invalid-feedback').text(password.data('pattern-mismatch'));
            $.spinner().stop();
            return false;
        }
        clientSideValidation.functions.validateForm(form.get(0), e);
    });

    $('#passwordreset-submit').on('mousedown', function(e) {
        $('form.new-password-form').trigger('submit');
    });
});
